/**
 * Vertical Tabs JavaScript
 *
 * This file defines behaviors of
 * the Vertical Tabs block.
 */
document.querySelectorAll('.vert-tabs')?.forEach((wrap) => {
	const page = document.getElementById('page');
	const orgPageClassName = page.getAttribute('class');
	const bg = wrap.firstElementChild;
	const orgClassName = bg.getAttribute('class');
	const labels = wrap.querySelectorAll('.vert-tabs__label');

	const checkClose = (e) => {
		const path = e.path || e.composedPath();
		const isOutside = !path.find((el) => el === wrap);
		if (isOutside) close();
	};

	const open = (label) => {
		observer.observe(wrap);
		document.body.removeEventListener('click', checkClose);
		wrap.classList.add('is-shown');
		const tab = label.nextElementSibling;
		labels.forEach((thisLabel) => thisLabel.classList.remove('active'));
		label.classList.add('active');
		const colorClassName = [...tab.classList].find((name) =>
			/has-\d-\d\d\d-color/.test(name)
		);
		const bgClassName = [...tab.classList].find((name) =>
			/has-\d-\d\d\d-background-color/.test(name)
		);
		const colorClasses = `${colorClassName} ${bgClassName}`;
		bg.setAttribute('class', `${orgClassName} ${colorClasses}`);
		page.setAttribute('class', `${orgPageClassName} ${colorClasses}`);
		document.body.addEventListener('click', checkClose);
	};

	const close = (label = null) => {
		observer.unobserve(wrap);
		document.body.removeEventListener('click', checkClose);
		wrap.classList.remove('is-shown');
		// eslint-disable-next-line no-unused-expressions
		label
			? label.classList.remove('active')
			: labels.forEach((thisLabel) =>
					thisLabel.classList.remove('active')
			  );
		page.setAttribute('class', orgPageClassName);
		bg.setAttribute('class', orgClassName);
	};

	labels?.forEach((label) => {
		label.addEventListener('click', (e) => {
			e.stopPropagation();
			if (label.classList.contains('active')) {
				close(label);
			} else {
				open(label);
			}
		});
	});

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					close();
				}
			});
		},
		{ rootMargin: '10px 0px 0px' }
	);
});
